import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    attendances: [],
    setelectedCall: undefined
  },
  mutations: {
    setAttendances(state, payload) {
      state.attendances = payload.reverse();
    },
    setSelectedCall(state, payload) {
      state.setSelectedCall = payload;
    },
    updateAttendance(state, payload) {
      let index = state.attendances.findIndex((attendance) => attendance.id == payload.id)
      state.attendances[index] = payload
    }
  },
  actions: {
    async newTarm({ commit, rootState }, payload) {
      let headerConfig = {
        headers: {
          Authorization: `bearer ${rootState.User.userToken}`
        }
      }
      let tarm = Object.assign({}, rootState.EmergencyCallLocal.call);
      delete tarm.victims
      tarm.victim = payload;
      console.log('Submiting post api/tarm/attendances body=', tarm);
      let retorno = await this.$http.post("api/tarm/attendances", tarm, headerConfig).then(response => {
        return response;
      }).catch(error => {
        return error;
      });
      return retorno;
    },
    selectedCall({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setSelectedCall', payload)
        resolve(payload);
        /* this.$http
          .get("api/tarm/"+payload.code)
          .then(response => {
            commit('setSelectedCall',response.data.attendance[0])
            resolve(response);
          })
          .catch(error => {
            reject(error);
          }); */
      });
    },
    updateSelectedCall({ commit, rootState }, payload) {
      let headerConfig = {
        headers: {
          Authorization: `bearer ${rootState.User.userToken}`
        }
      }
      return new Promise((resolve, reject) => {
        let callObj = Object.assign({}, rootState.EmergencyCallLocal.call)
        callObj.location = {
          address: callObj.address,
          latitude: callObj.latitude,
          longitude: callObj.longitude
        }
        if (payload && payload.cancel) {
          callObj.status = 3
        }
        else {
          callObj.status = callObj.attendance_status_id == 1 ? 2 : 3
        }
        callObj.attendance_status_id = callObj.status;
        console.log('teste')
        this.$http.put("api/tarm/attendances/" + callObj.id, callObj, headerConfig).then(response => {
          commit('setSelectedCall', undefined)
          commit('updateAttendance', response.data.attendance)
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    loadAttendances({ commit, rootState, getters }, payload) {
      let headerConfig = {
        headers: {
          Authorization: `bearer ${rootState.User.userToken}`
        }
      }
      let role = getters.user.roles[0].name
      this.$http.get(`api/${role}/attendances`, headerConfig).then(response => {
        commit("setAttendances", response.data.attendances);
      });
    },

    loadAttendancesDoctor({ commit, rootState }, payload) {
      let headerConfig = {
        headers: {
          Authorization: `bearer ${rootState.User.userToken}`
        }
      }
      this.$http.get("api/regulatory-physician/attendances", headerConfig).then(response => {
        commit("setAttendances", response.data.attendances);
      });
    },

  },
  getters: {
    getAttendances(state) {
      return state.attendances;
    },
    getSelectedCall(state) {
      return state.selectedCall
    }
  }
};
